import { render } from "./NoImg.vue?vue&type=template&id=8a6bd0c2"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./NoImg.vue?vue&type=style&index=0&id=8a6bd0c2&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script